import {DataApi} from '../data-api';
import {DataApiDistinctValues, DataApiResult, NewsItem} from '../../../types/data-api';
import {DataApiEndpoint} from '../data-api-endpoint';
import {NewsFilter, NewsSettings} from '../../../plugins/news/filter';

/**
 * Endpoint for getting news.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class NewsEndpoint extends DataApiEndpoint {
  protected _api: DataApi;

  constructor(api: DataApi) {
    super(api);
    this._api = api;
  }

  /**
   * Finds news by a filter.
   *
   * @param {NewsSettings|null} settings Plugin settings
   * @param {NewsFilter|null} [filter] Filter
   * @returns {Promise<DataApiResult<NewsEndpoint>>}
   */
  public async find(
    settings: NewsSettings | null = null,
    filter: NewsFilter | null = null
  ): Promise<DataApiResult<NewsItem>> {
    return fetch(this.buildUrl(settings, filter, [
      'dataApi[preset]=news'
    ]))
      .then(response => {
        if (response.status !== 200) {
          throw new Error(`Fetching endpoint failed: ${response.status} ${response.statusText}`);
        }
        return response.json();
      })
      .then((response: DataApiResult<NewsItem>) => {
        return response;
      });
  }

  /**
   * Gets distinct values for news.
   *
   * @param {NewsSettings|null} [settings] Plugin settings
   * @returns {Promise<DataApiDistinctValues>}
   */
  public async distinctValues(settings: NewsSettings | null = null): Promise<DataApiDistinctValues> {
    return fetch(this.buildUrl(settings, null, [
      'dataApi[preset]=news',
      'dataApi[rows]=9999',
      'dataApi[distinctValues]=1'
    ]))
      .then(response => {
        if (response.status !== 200) {
          throw new Error(`Fetching endpoint failed: ${response.status} ${response.statusText}`);
        }
        return response.json();
      })
      .then((response: DataApiDistinctValues) => {
        return response;
      });
  }
}
